module.exports = __webpack_public_path__ + "blackoils.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blackoils.png
// module id = 863
// module chunks = 0